const perkIcons = {
  cabana: {
    icon: 'cabana',
    keyword: 'cabana',
  },
  foodCredit: {
    icon: 'food',
    keyword: 'food',
  },
  freePlay: {
    icon: 'monetization',
    keyword: 'free',
  },
  hotel: {
    icon: 'hotel',
    keyword: 'room',
  },
  spa: {
    icon: 'spa',
    keyword: 'spa',
  },
  trip: {
    icon: 'trip',
    keyword: 'trip',
  },
};

export function getPerkIcon(category) {
  return perkIcons[category] ? perkIcons[category].icon : 'default';
}

export function mapPerkIconsToAllPerks(perks) {
  return perks.map(({ primePerkId, name, description, wscore, primeTokens, category }) => {
    return {
      primePerkId,
      name,
      description,
      wscore,
      primeTokens,
      category,
      icon: getPerkIcon(category),
    };
  });
}

// TODO: Remove. They don't want to map icon by name.
// export function getRedeemedPerkIcon(redeemedPerkName) {
//   for (let key in perkIcons) {
//     let keyword = perkIcons[key].keyword;
//
//     if (redeemedPerkName.toLowerCase().includes(keyword)) {
//       return perkIcons[key].icon;
//     }
//   }
//
//   return 'default';
// }
